import { getRoute } from '@/helpers/RouteHelper';
import axios from 'axios';
import { navigate } from 'gatsby';

const urlPrefix = process.env.api_url ?? '';

const axiosInterceptorInstance = axios.create({
  baseURL: urlPrefix,
});

// eslint-disable-next-line complexity
const handleServerError = (response: any) => {
  const { country } = getRoute(window.location.pathname);
  if (
    response.config.url !==
      `/screening/?countryCode=${country}&relativeUrl=MDMScreening/GetCustomerProfileFE` &&
    response.config.url !==
      `/inforce/?countryCode=${country}&relativeUrl=Proposal/ResendEmail` &&
    response.status >= 500
  ) {
    redirectToErrorPage();
  }
};

const redirectToErrorPage = () => {
  if (typeof window !== 'undefined') {
    const { country, entity } = getRoute(window.location.pathname);
    navigate(`/${country}/${entity}/error`);
  }
};

axiosInterceptorInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const response = error.response;
    handleServerError(response);
  },
);

// Add a request interceptor to modify the URL before the request is sent
axiosInterceptorInstance.interceptors.request.use(
  function (config) {
    const { country } = getRoute(window.location.pathname);
    const index = config.url?.indexOf('?');
    if (index !== undefined) {
      if (index !== -1) {
        config.url =
          config.url?.slice(0, index + 1) +
          'countryCode=' +
          country +
          '&' +
          config.url?.slice(index + 1);
      }
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

export default axiosInterceptorInstance;
